import { Button, Form, Input, Modal } from 'antd';

//Import css
import { useMutation } from '@apollo/client';
import { useForm } from 'antd/es/form/Form';
import { useContext } from 'react';
import { FloorPlan } from '../../../__generated__/graphql';
import { AppContext } from '../../../AppContext';
import { AppActionType, AppContextType } from '../../../types/appContext.type';
import { UPDATE_FLOOR_PLAN } from '../../vastu-assessment/graphql/mutations';
import '../styles/shareFeedbackModal.less';

const AddDetailsModal = ({
  floorPlan,
  setDetailsModalOpen,
  open,
}: {
  floorPlan: FloorPlan;
  setDetailsModalOpen: (open: boolean) => void;
  open: boolean;
}) => {
  const { dispatch } = useContext(AppContext) as AppContextType;

  const form = useForm();
  const [updateFloorPlan, { loading }] = useMutation(UPDATE_FLOOR_PLAN);
  const handleUpdateDetails = async (values: {
    companyName?: string;
    address?: string;
  }) => {
    const { companyName, address } = values;
    const res = await updateFloorPlan({
      variables: {
        data: {
          floorPlanId: floorPlan?.id as string,
          companyName,
          address,
        },
      },
    });
    setDetailsModalOpen(false);
    if (res?.data?.updateFloorPlanWeb?.data) {
      dispatch({
        type: AppActionType.setFloorPlan,
        data: res?.data?.updateFloorPlanWeb?.data,
      });
    }
  };
  return (
    <Modal
      className="share-feedback-modal"
      open={open}
      onCancel={() => setDetailsModalOpen(false)}
      footer={null}
      title="Add Additional Details"
      confirmLoading={loading}
    >
      <Form layout="vertical" form={form[0]} onFinish={handleUpdateDetails}>
        <Form.Item
          label="Company name"
          name="companyName"
          initialValue={floorPlan?.companyName}
        >
          <Input placeholder="please enter company name" />
        </Form.Item>
        <Form.Item
          label="Address"
          name="address"
          initialValue={floorPlan?.address}
        >
          <Input placeholder="please enter address" />
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form>
    </Modal>
  );
};

export default AddDetailsModal;
